// UTM tracking utility
export const captureUTMParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {
    utm_source: urlParams.get('utm_source'),
    utm_medium: urlParams.get('utm_medium'),
    utm_campaign: urlParams.get('utm_campaign'),
    utm_term: urlParams.get('utm_term'),
    utm_content: urlParams.get('utm_content'),
  };

  // Filter out null values
  const filteredParams = Object.fromEntries(
    Object.entries(utmParams).filter(([_, value]) => value !== null)
  );

  if (Object.keys(filteredParams).length > 0) {
    localStorage.setItem('utm_params', JSON.stringify(filteredParams));
    console.log('📊 UTM parameters captured:', filteredParams);
  }

  return filteredParams;
};

export const getStoredUTMParams = () => {
  const stored = localStorage.getItem('utm_params');
  return stored ? JSON.parse(stored) : {};
};

export const trackRegistration = (userDetails = {}) => {
  const utmParams = getStoredUTMParams();
  
  // Send sign_up to GTM only (not GA4 directly)
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'sign_up',
      method: 'email',
      user_email: userDetails.email || 'unknown',
      user_id: userDetails.email || 'unknown',
      ...utmParams
    });
    console.log('📊 Sign-up event sent to GTM only:', {
      event: 'sign_up',
      user_email: userDetails.email,
      utm_params: utmParams
    });
  }

  // Clear UTM params after successful registration
  localStorage.removeItem('utm_params');
};